import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'
import { PatchCollection } from '@reduxjs/toolkit/dist/query/core/buildThunks'
import { ShoppingCartItem } from '@dtx-company/flow-codegen/src/code/generated.types'
import {
  addPrintStoreUpdateQueryData,
  confirmAndDeletePrintStoreUpdateQueryData,
  deletePrintStoreUpdateQueryData,
  editPrintStoreUpdateQueryData
} from './printStoreQueries.utils'
import { printStoreQueries } from './printStoreQueries'
import { sendErrorNotification } from '../../../utils/notifications'

export const getPatchResultAddItem = (
  item: ShoppingCartItem,
  dispatch: ThunkDispatch<any, any, AnyAction>
): PatchCollection => {
  return dispatch(
    printStoreQueries.util.updateQueryData('shoppingCart', {}, currentState => {
      addPrintStoreUpdateQueryData(currentState, item)
    })
  )
}

export const getPatchResultEditItem = (
  itemId: string,
  newQuantity: number,
  dispatch: ThunkDispatch<any, any, AnyAction>
): PatchCollection => {
  return dispatch(
    printStoreQueries.util.updateQueryData('shoppingCart', {}, currentState =>
      editPrintStoreUpdateQueryData(currentState, itemId, newQuantity)
    )
  )
}

export const getPatchResultDeleteItem = (
  itemId: string,
  dispatch: ThunkDispatch<any, any, AnyAction>
): PatchCollection => {
  return dispatch(
    printStoreQueries.util.updateQueryData('shoppingCart', {}, currentState => {
      deletePrintStoreUpdateQueryData(currentState, itemId)
    })
  )
}

export const getPatchResultConfirmAndDeleteItem = (
  dispatch: ThunkDispatch<any, any, AnyAction>
): PatchCollection => {
  return dispatch(
    printStoreQueries.util.updateQueryData('shoppingCart', {}, currentState => {
      confirmAndDeletePrintStoreUpdateQueryData(currentState)
    })
  )
}

export const undoPatch = (patch: PatchCollection, error: string): void => {
  patch.undo()
  sendErrorNotification(error)
}
